import { PROCESS_CHANGED, LOCALE_CHANGED } from '../../constants'
import { selectors as backendSelectors } from '../Backend'

export { default as getTexts } from '../../store/localizer'

export const constants = {
    PROCESS_CHANGED,
    LOCALE_CHANGED,
}

export const selectors = {
    getActiveServerId: state => backendSelectors.getActiveServerId(state),
    // getActiveRunningProcesses: state => backendSelectors.getActiveRunningProcesses(state),
    isPlaying: state => backendSelectors.isPlaying(state),
}



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/imports.js